// 中国語（簡体字）の表（鍵は日本語の文言そのまま。足りない鍵は tools/devtest/i18n_keys.py で分かる）。
// パラメータの名前は仮（用語を決めたら直す）。
export const zh: Record<string, string> = {
  "歌のトラック": "人声音轨",
  "音符を描いて歌わせる": "画音符并让它演唱",
  "伴奏のトラック": "伴奏音轨",
  "音声ファイルを選択（画面にドロップしても追加できます）": "选择音频文件（也可以拖放到窗口中）",
  "ドロップすると伴奏トラックとして追加します": "松开后将音频文件添加为伴奏音轨",
  "音声ファイル（wav・mp3・flac など）をドロップしてください": "请拖放音频文件（wav、mp3、flac 等）",
  "名前を変える": "重命名",
  "トラックを削除": "删除音轨",
  "⌘Z で戻せます": "可用 ⌘Z 撤销",
  "歌のトラックは 1 本は残す必要があります（ピアノロールで使うため）": "至少需要保留一条人声音轨（钢琴卷帘要用）",
  "トラックを削除しました: {name}（⌘Z で戻せます）": "已删除音轨：{name}（可用 ⌘Z 撤销）",
  "トラック {n}": "音轨 {n}",
  "読み込み中: {name}": "正在读取：{name}",
  "音声ファイルを読めませんでした: {name}（{e}）": "无法读取音频文件：{name}（{e}）",
  "伴奏トラックを追加しました: {name}（{sec} 秒）": "已添加伴奏音轨：{name}（{sec} 秒）",
  "クリック・ドラッグ: 再生位置を移動": "点击・拖动：移动播放位置",
  "ドラッグ: 左右に移動　⌘/Ctrl+ホイール・ピンチ: 時間方向の拡大縮小": "拖动：左右移动　⌘/Ctrl+滚轮・双指捏合：缩放时间轴",
  "ドラッグ: 伴奏を移動（スナップしない）　右クリック: 名前を変える・削除": "拖动：移动伴奏（不吸附）　右键：重命名・删除",
  "ドラッグ: トラックを移動（音符とパラメータの曲線も一緒に）　⌥+ドラッグ: スナップしない　右クリック: 名前を変える・削除": "拖动：移动音轨（音符和参数曲线一起移动）　⌥+拖动：不吸附　右键：重命名・删除",
  "ドラッグ: 伴奏の再生範囲を詰める・戻す（スナップしない）": "拖动：裁剪或恢复伴奏的播放范围（不吸附）",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない）　⌥+ドラッグ: スナップしない": "拖动：改变音轨范围（范围外的音符不演唱）　⌥+拖动：不吸附",
  "クリック・ドラッグ: ピアノロールの表示位置を移動　ホイール: 上下　Shift+ホイール: 左右　⌘/Ctrl+ホイール・ピンチ: 拡大縮小　音声ファイルをドロップ: 伴奏トラックを追加": "点击・拖动：移动钢琴卷帘的显示位置　滚轮：上下　Shift+滚轮：左右　⌘/Ctrl+滚轮・双指捏合：缩放　拖放音频：添加伴奏音轨",
  "ダブルクリック: 名前を変える": "双击：重命名",
  "音量": "音量",
  "パン": "声像",
  "中央": "居中",
  "左": "左",
  "右": "右",
  "ミュート": "静音",
  "ソロ": "独奏",
  "ドラッグ: 音素の境界を移動（休符の後の先頭は前の休符の中まで伸ばせます。フレーズの終わりは動きません）　ダブルクリック: 元に戻す": "拖动：移动音素边界（休止符后的开头可延伸到该休止符内；乐句结尾不可移动）　双击：复原",
  "音素": "音素",
  "波形": "波形",
  "ドラッグで高さを変える": "拖动以调整高度",
  "閉じる（Esc）": "关闭（Esc）",
  "書き出し": "导出",
  "ファイル名": "文件名",
  "形式": "格式",
  "チャンネル": "声道",
  "ステレオ": "立体声",
  "モノ（パンは掛けない）": "单声道（不应用声像）",
  "ビット深度": "位深度",
  "32 bit 浮動小数": "32 位浮点",
  "無題": "未命名",
  "ミックスを書き出す": "导出混音",
  "再生と同じ音（ミュート・ソロ、トラックの音量とパン、エフェクターを反映）": "与播放相同（反映静音・独奏、音轨的音量和声像、效果器）",
  "トラックを別々に書き出す": "分别导出各音轨",
  "選んだトラックを書き出す（{n} ファイル）": "导出所选音轨（{n} 个文件）",
  "書き出し中…": "正在导出…",
  "レンダリング中（残り {n} フレーズ）": "合成中（还剩 {n} 句）",
  "エンジンにつながっていないので書き出せません。": "未连接引擎，无法导出。",
  "連続音の歌詞 {n} 個を単独音に直しました": "已将 {n} 个连续音歌词转换为单独音",
  "ブレスの記号 {n} 個を休符にしました": "已将 {n} 个换气记号改为休止",
  "読めない歌詞 {n} 個を休符にしました: {list}": "已将 {n} 个无法读取的歌词改为休止：{list}",
  "ブレスを {n} 個入れました": "已加入 {n} 个换气",
  "書き出しました: {names}": "已导出：{names}",
  "書き出しに失敗しました: {e}": "导出失败：{e}",
  "設定": "设置",
  "画面の言語": "界面语言",
  "変更するとページを再読み込みします（編集内容は自動保存から復元されます）": "更改后会重新加载页面（编辑内容将从自动保存继续）",
  "アクセントカラー": "强调色",
  "音符・選んだ所・つまみの色。トラックの色もここから作ります": "音符、选中部分和控件的颜色。音轨颜色也由它生成",
  "好きな色を選ぶ": "选择任意颜色",
  "自由選択": "自定义",
  "既定に戻す": "恢复默认",
  "mel の配色": "mel 配色",
  "下のパネルの mel の色": "下方面板中 mel 的颜色",
  "エンジン": "引擎",
  "GPU で計算する（実験的・Chrome 向け。変更は読み込み直しで反映）": "使用 GPU 计算（实验性，面向 Chrome；重新加载后生效）",
  "Safari では使えません（WebGPU 入りの部品を読むとページが読み込み直されるため）": "Safari 中不可用（加载 WebGPU 版组件会导致页面被重新加载）",
  "このブラウザは WebGPU に対応していません": "此浏览器不支持 WebGPU",
  "この環境では GPU を使えません（WebGPU の準備ができません）": "此环境无法使用 GPU（无法初始化 WebGPU）",
  "VocaTab のプロジェクト": "VocaTab 工程",
  "（未保存）": "（未保存）",
  "編集はブラウザの中に自動で保存しています（読み込み直しても続きから）": "编辑内容会自动保存在浏览器中（重新加载后可继续）",
  "自動保存 {time}": "已自动保存 {time}",
  "自動保存に失敗: {e}": "自动保存失败：{e}",
  "新規": "新建",
  "サンプル曲から始める": "从示例曲开始",
  "開く": "打开",
  "⌘O　.svsproj か、音声も含めた .zip": "⌘O　.svsproj 或包含音频的 .zip",
  "保存": "保存",
  "名前を付けて保存": "另存为",
  "音声も含めて書き出す": "连同音频导出",
  "伴奏の音声もまとめた .zip": "包含伴奏音频的 .zip",
  "楽譜を読み込む": "导入乐谱",
  "MusicXML（.musicxml・.xml・.mxl）・UST。新しい歌のトラックにする": "MusicXML（.musicxml・.xml・.mxl）・UST，作为新的人声音轨",
  "今のプロジェクトを閉じて、サンプル曲から始めますか？（保存していない変更は消えます）": "关闭当前工程并从示例曲开始吗？（未保存的更改将丢失）",
  "新しいプロジェクトにしました": "已新建工程",
  "音声も含めたプロジェクト": "包含音频的工程",
  "開きました: {name}": "已打开：{name}",
  "開けませんでした: {name}": "无法打开：{name}",
  "伴奏の音声が見つかりません": "找不到伴奏音频",
  "プロジェクトファイルには伴奏の音声は含まれていません。元の音声ファイルを選択してください（複数選択可。内容で照合するため、移動や名前変更があっても問題ありません）。": "工程文件中不包含伴奏音频本身。请选择原始音频文件（可一次选择多个；按内容指纹匹配，因此即使文件位置或名称改变也没关系）。",
  "ファイルを選ぶ": "选择文件",
  "あとで（音を出さずに続ける）": "稍后（不发声继续）",
  "伴奏を再リンクしました: {names}": "已重新关联伴奏：{names}",
  "リンクしました: {names}": "已关联：{names}",
  "一致するファイルが見つかりませんでした: {names}": "没有匹配的文件：{names}",
  "楽譜を読めませんでした: {name}": "无法读取乐谱：{name}",
  "楽譜を読み込みました: {name}（{tracks} トラック、{notes} 音符、テンポ {bpm}）": "已导入乐谱：{name}（{tracks} 条音轨，{notes} 个音符，速度 {bpm}）",
  "　注意: {w}": "　注意：{w}",
  "保存しました": "已保存",
  "保存しました: {name}": "已保存：{name}",
  "保存できませんでした: {e}": "无法保存：{e}",
  "ダウンロードしました": "已下载",
  "音声も含めて書き出しました: {name}（{mb} MB）": "已连同音频导出：{name}（{mb} MB）",
  "ルーム": "房间",
  "ホール": "大厅",
  "プレート": "板式",
  "アリーナ": "体育场",
  "オン/オフ": "开/关",
  "イコライザー": "均衡器",
  "ローカット": "低切",
  "周波数": "频率",
  "ゲイン": "增益",
  "幅（Q）": "宽度（Q）",
  "空いている所をダブルクリックでポイントを追加。ドラッグで移動、ポイントの上でホイールを回すと幅（Q）を調整、右クリックまたは Delete で削除します。⌐ はローカットです。":
    "双击空白处添加控制点。拖动可移动，在控制点上滚动滚轮调整宽度（Q），右键或 Delete 删除。⌐ 为低切。",
  "濁り": "浑浊",
  "こもり": "发闷",
  "鼻": "鼻音",
  "抜け": "穿透",
  "歯擦音": "齿音",
  "空気": "空气感",
  "合成が完了すると、ここに声のスペクトルが表示されます": "合成完成后，这里会显示声音的频谱",
  "幅 {q}": "宽度 {q}",
  "ローカット: {f}": "低切：{f}",
  "ポイントは {n} 個まで追加できます": "最多 {n} 个控制点",
  "このポイントを削除": "删除此控制点",
  "コンプレッサー": "压缩器",
  "スレッショルド {db} dB": "阈值 {db} dB",
  "スレッショルド": "阈值",
  "アタック": "启动时间",
  "レシオ": "比率",
  "リバーブ": "混响",
  "始まり": "起始",
  "量": "量",
  "長さ": "长度",
  "長さ {d} 秒 · 量 {w} % · 始まり {p} ms": "长度 {d} 秒 · 量 {w} % · 起始 {p} ms",
  "ポイントをドラッグして、プリディレイ・ミックス量・残響の長さを調整します。ダブルクリックで種類の値に戻ります。": "拖动点以调整预延迟、混合量和余响长度。双击点恢复为该类型的数值。",
  "{name}: {value}（上下にドラッグで回す、⇧ で細かく、ダブルクリックで戻す）": "{name}：{value}（上下拖动旋转，⇧ 精细调节，双击复原）",
  "Space: 再生・一時停止　1: 選択　2: 鉛筆　3: ピッチのペン　Delete: 削除　⌘C / ⌘V: コピー / 再生位置に貼り付け　⌘Z / ⇧⌘Z: 取り消し / やり直し　↑↓: 半音（⇧ でオクターブ）": "Space：播放・暂停　1：选择　2：铅笔　3：音高笔　Delete：删除　⌘C / ⌘V：复制 / 粘贴到播放位置　⌘Z / ⇧⌘Z：撤销 / 重做　↑↓：半音（⇧ 为八度）",
  "{n} 個の音符をコピーしました": "已复制 {n} 个音符",
  "{n} 個の音符を切り取りました": "已剪切 {n} 个音符",
  "{n} 個の音符を再生位置に貼り付けました": "已在播放位置粘贴 {n} 个音符",
  "コピーする音符を選んでください": "请先选择要复制的音符",
  "貼り付ける音符がありません（先に ⌘C でコピー）": "没有可粘贴的音符（请先用 ⌘C 复制）",
  "パラメータ": "参数",
  "音素のタイミング": "音素时间",
  "実験版": "实验版",
  "モック": "模拟",
  "エンジン未接続（モック）": "未连接引擎（模拟）",
  "レンダリング中 {done}/{all} フレーズ": "合成中 {done}/{all} 句",
  "レンダリング完了": "已合成",
  "レンダリング完了（待機中）": "已合成（引擎待机中）",
  "モデルを読み込み中 {p}%（{mb} / {total} MB）": "正在加载模型 {p}%（{mb} / {total} MB）",
  "選択 (1)": "选择 (1)",
  "音符を描く (2)": "画音符 (2)",
  "ピッチのペン (3)": "音高笔 (3)",
  "ピッチの線": "音高线",
  "再生・一時停止（Space）": "播放・暂停（Space）",
  "テンポは 20〜400 の数で入れてください（{s}）": "请输入 20～400 之间的速度（{s}）",
  "拍子は「3」「6/4」のように、4 分音符を 1 拍として入れてください（{s}）": "请以四分音符为一拍输入拍号，例如“3”“6/4”（{s}）",
  "1 小節の拍の数は 1〜16 です": "每小节拍数为 1～16",
  "前回の続きから開きました（{at} に自動保存）": "已从上次继续（{at} 自动保存）",
  "自動保存を読めませんでした: {e}": "无法读取自动保存：{e}",
  "計算中…（フレーズの合成が終わると表示されます）": "计算中…（引擎合成乐句后显示）",
  "{sec} s（{fr} フレーム）　{hz} Hz（bin {bin}）　{val}": "{sec} s（第 {fr} 帧）　{hz} Hz（bin {bin}）　{val}",
  "① ボコーダに入れる mel（postfilter 後）": "① 输入声码器的 mel（postfilter 之后）",
  "② ボコーダの出力の mel（声の調整なし）": "② 声码器输出的 mel（不含声音调整）",
  "③ 声の調整を掛けた音の mel": "③ 应用声音调整后的 mel",
  "ボコーダの入力": "声码器输入",
  "ボコーダの出力": "声码器输出",
  "声の調整後": "声音调整后",
  "エンジンの mel。② は声の調整を掛けない音（②③ はオンのときだけ作る）": "引擎的 mel。② 为不应用声音调整的声音（②③ 仅在开启时生成）",
  "仮のデータです（エンジン未接続）。オフの行は計算しません": "模拟数据（未连接引擎）。关闭的行不计算",
  "（伸ばし）": "（延长音）",
  "{n} 個": "{n} 个",
  "{ph} · {pitch} · {beats} 拍": "{ph} · {pitch} · {beats} 拍",
  "{lyric} ほか（まとめて変える）": "{lyric} 等（一起修改）",
  "抑揚": "抑扬",
  "AI が付けた抑揚（しゃくり・こぶし・音の移り方など、音符の高さからのずれ）の倍率（0 で音符の高さどおり）。ダブルクリックで 1 に戻す":
    "AI 生成的抑扬（滑音、转音、音间过渡等相对音符音高的偏离）的倍率（0 为完全按音符音高）。双击恢复为 1",
  "ビブラート": "颤音",
  "AI が付けたビブラートの幅の倍率（0 で消える）。ダブルクリックで 1 に戻す": "AI 生成的颤音幅度倍率（0 为去除）。双击恢复为 1",
  "ピッチ": "音高",
  "抑揚とビブラートを取り直す": "重新生成抑扬和颤音",
  "声": "音色",
  "息づかいや音色の細部を取り直す": "重新生成气息和音色细节",
  "最初のテイク": "初始版本",
  "{n} 回目": "第 {n} 次",
  "{n} 個をリテイクしました": "已重新生成 {n} 个",
  "この音符だけ AI の生成をやり直す": "仅对这些音符重新生成 AI 结果",
  "リテイク": "重新生成",
  "一つ前のテイクに戻す": "返回上一个版本",
  "一つ前": "上一个",
  "最初のテイク（初期の乱数）に戻す": "返回初始版本（初始随机数）",
  "最初": "初始",
  "ピッチのずれ": "音高偏移",
  "抑揚の強さ": "抑扬强度",
  "ビブラートの強さ": "颤音强度",
  "テンション": "张力",
  "張る": "紧",
  "緩む": "松",
  "ブレシネス": "气声",
  "息が多い": "气息多",
  "息が少ない": "气息少",
  "ジェンダー": "共振峰",
  "男性的": "低沉",
  "女性的": "明亮",
  "有声度": "浊音度",
  "有声": "浊音",
  "無声": "清音",
  "子音の強さ": "辅音强度",
  "強い": "强",
  "弱い": "弱",
  "響き": "共鸣",
  "響く": "响亮",
  "こもる": "闷",
  "うなり": "嘶吼",
  "なし": "无",
  "表示/非表示": "显示・隐藏",
  "クリックで前面に表示（編集できるのは最前面の曲線）": "点击：置于最前（绘制的是最前面的曲线）",
  "パラメータを選び直す": "更换参数",
  "この曲線を閉じる": "关闭此曲线",
  "曲線を追加": "添加曲线",
  "鉛筆": "铅笔",
  "直線": "直线",
  "消しゴム（右ドラッグでも消せる）": "橡皮擦（右键拖动也可擦除）",
  "ドラッグ: 最前面の曲線を描く　右ドラッグ: 消去（初期値に戻す）　タブ名をクリックで前面に表示": "拖动：绘制最前面的曲线　右键拖动：擦除（恢复默认值）　点击标签名称可置于最前",
  "NSF-HiFiGAN では効きません": "对 NSF-HiFiGAN 无效",
  "ドラッグ: ピッチの線を描く（ピッチのずれに書き込む）　右ドラッグ: 消去して元に戻す": "拖动：绘制音高线（写入音高偏移）　右键拖动：擦除并恢复",
  "ドラッグ: トラックの範囲を変更（範囲の外の音符は歌わない、端をまたぐ音符は端で切れる）　⌥: スナップしない": "拖动：改变音轨范围（范围外的音符不演唱，跨越边界的音符在边界处截断）　⌥：不吸附",
  "ドラッグ: 長さを変更": "拖动：改变长度",
  "ドラッグ: 移動（Shift で選択に追加）　ダブルクリック: 歌詞を入力": "拖动：移动（Shift 添加到选择）　双击：输入歌词",
  "ドラッグ: 音符を描く": "拖动：画音符",
  "ドラッグ: 範囲選択　ホイール: 上下　Shift+ホイール: 左右　⌘+ホイール: 横の拡大　⌥+ホイール: 縦の拡大": "拖动：框选　滚轮：上下　Shift+滚轮：左右　⌘+滚轮：横向缩放　⌥+滚轮：纵向缩放",
  "プロジェクトのファイルとして読めません（JSON ではない）": "无法作为工程文件读取（不是 JSON）",
  "この SVS のプロジェクトのファイルではありません": "这不是本 SVS 的工程文件",
  "新しいバージョン（{v}）で保存されたファイルです。アプリを更新してください": "该文件由新版本（{v}）保存。请更新应用",
  "歌のトラックがありません": "没有人声音轨",
  "（中身が保存したときと違います）": "（内容与保存时不同）",
  "zip として読めません": "无法作为 zip 读取",
  "zip の目次が壊れています": "zip 目录已损坏",
  "圧縮された zip には対応していません（{name}）": "不支持压缩的 zip（{name}）",
  "zip の中に project.svsproj がありません": "zip 中没有 project.svsproj",
  "解析に失敗: {e}": "分析失败：{e}",
  "合成に失敗: {e}": "合成失败：{e}",
  "エンジンとの通信に失敗: {e}": "与引擎通信失败：{e}",
  "メロディ": "主旋律",
  "MusicXML として読めません（XML が壊れています）": "无法作为 MusicXML 读取（XML 已损坏）",
  "<part> がありません": "没有 <part>",
  "{all} パートのうち、歌詞のある {n} パートを読みました": "在 {all} 个声部中读取了有歌词的 {n} 个",
  "声部が {n} つあります（未対応）。全部つなげて読むので譜面と違う音になります": "有 {n} 个声部（不支持）。会全部连在一起读取，因此与乐谱不同",
  "<backup>/<forward> があります（未対応）。時刻がずれます": "含有 <backup>/<forward>（不支持）。时间会有偏差",
  "繰り返し記号があります（未対応）。展開せず、書かれた順に 1 回だけ歌います": "含有反复记号（不支持）。不展开，按书写顺序只唱一遍",
  "divisions が途中で変わります（未対応）。最初の値を使います": "divisions 中途变化（不支持）。使用最初的值",
  "テンポが途中で変わります（未対応）。最初の値 {bpm} を使います": "速度中途变化（不支持）。使用最初的值 {bpm}",
  "テンポの指定がありません。120 とみなします": "没有指定速度。按 120 处理",
  ".mxl の中に楽譜の XML が見つかりません": ".mxl 中找不到乐谱 XML",
  "読める楽譜は UST と MusicXML（.musicxml・.xml・.mxl）です: {name}": "可读取的乐谱为 UST 和 MusicXML（.musicxml・.xml・.mxl）：{name}",
  "歌い手と声": "歌手与声音",
  "エフェクター": "效果",
  "レンダリング": "合成状态",
  "{n} つ有効": "{n} 个启用",
  "エンジン未接続": "未连接引擎",
  "{done}/{all} フレーズ": "{done}/{all} 句",
  "完了": "完成",
  "歌い手": "歌手",
  "モデル": "模型",
  "日本語": "日语",
  "韓国語": "韩语",
  "「{name}」を鳴らせません: {e}": "无法播放“{name}”：{e}",
  "「{name}」のエフェクトを掛けられません: {e}": "无法对“{name}”应用效果：{e}",
  "{sec} 秒からのフレーズに不正な値が {n} 個ありました（無音に置き換えて再生します）": "从 {sec} 秒开始的乐句中有 {n} 个无效值（替换为静音播放）",
  "ボコーダ": "声码器",
  "NSF-HiFiGAN は調波・雑音の分岐を持たないため、音量とうなり以外は効きません。": "NSF-HiFiGAN 没有谐波和噪声分支，因此除音量和嘶吼外均无效。",
  "声の調整": "声音调整",
  "ダブルクリックで元に戻す": "双击复原",
  "解析完了": "已分析",
  "合成中": "合成中",
  "失敗": "失败",
  "フレーズ {i}": "第 {i} 句",
  "エンジンは未接続です（モック）。フレーズごとの計算の状況がここに並びます。": "引擎未连接（模拟）。各乐句的计算状态将显示在这里。",
  "未計算": "未计算",
  "藤": "紫藤",
  "夜桜": "夜樱",
  "氷": "冰",
  "墨": "墨",
  "設定（言語・アクセントカラー・mel の配色）": "设置（语言・强调色・mel 配色）",
  "ファイル ▾": "文件 ▾",
  "トラック": "音轨",
  "トラックを追加（歌・伴奏）": "添加音轨（人声・伴奏）",
  "スナップ": "吸附",
  "スナップ 自動": "吸附 自动",
  "1 小節": "1 小节",
  "1/8 の 3 連": "1/8 三连音",
  "スナップなし": "不吸附",
  "WAV に書き出す": "导出为 WAV",
  "上下にドラッグ: トラック一覧の高さを変更（ダブルクリック: 全トラックが収まる高さ）": "上下拖动：调整音轨列表的高度（双击：显示全部音轨）",
  "再生": "播放",
  "サイドバーの表示/非表示": "显示 / 隐藏侧边栏",
  "停止して先頭に戻る": "停止并回到开头",
  "ループ（今後対応予定）": "循环（后续实现）",
  "クリック: テンポを変更": "点击：更改速度",
  "クリック: 拍子を変更": "点击：更改拍号",
  "再生位置を追う": "跟随播放位置",
  "クリック: ここにブレスを入れる": "点击：在此加入气息",
  "クリック: 別のブレスに替える　右クリック: 消す": "点击：换成其他气息　右键：删除",
  "ブレス": "气息",
  "すべてに入れる": "全部加入",
  "すべて消す": "全部删除",
  "ブレスの合成に失敗: {e}": "气息合成失败：{e}",
  "この歌い手にはブレスの素材がありません。": "此歌手没有气息素材。",
  "音素のタイミングの「+ br」をクリックしても 1 つずつ入れられます（直前の音符から 0.1 秒以上空いた音符の前）。": "也可以在音素时序面板中点击“+ br”逐个加入（在与前一个音符间隔 0.1 秒以上的音符之前）。",
};
